import { styled } from '@linaria/react';

export const AppWrapper = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: var(--background-color);
    color: var(--text-color);

    @media (max-width: 768px) {
        height: auto;
        min-height: 100vh;
        min-height: 100dvh;
    }

    @media print {
        height: auto;
        overflow: visible;
    }
`;

export const PageWrapper = styled.div`
    flex: 1;
    min-height: 0;
    overflow: hidden;
    position: relative;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
    }

    @media print {
        overflow: visible;
        position: static;
    }
`;

export const ContentWrapper = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    background-color: var(--content-background);

    @media (max-width: 768px) {
        overflow: visible;
        height: auto;
    }

    @media print {
        height: auto;
        overflow: visible;
    }
`;

export const PageHeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--header-background);
    border-bottom: 1px solid var(--border-color);
    position: sticky;
    top: 0;
    z-index: 5;
`;

export const MainContentWrapper = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        padding: 4px;
        height: auto;
        min-height: 0;
        overflow-y: visible;
        padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 1rem);
    }
    
    @media print {
        height: auto;
        overflow: visible;
    }
`;

export const LoadingWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: var(--background-color);
`;

export const ErrorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: var(--background-color);
    color: var(--error-color);
    text-align: center;
    padding: 15px;
`;
